export const RESET_BILL_CONFIG = "RESET_BILL_CONFIG"

export const QUERY_BILL_CONFIGS = "QUERY_BILL_CONFIGS"
export const QUERY_BILL_CONFIGS_SUCCESS = "QUERY_BILL_CONFIGS_SUCCESS"
export const QUERY_BILL_CONFIGS_FAILED = "QUERY_BILL_CONFIGS_FAILED"

export const GET_BILL_CONFIGS = "GET_BILL_CONFIGS"
export const GET_BILL_CONFIGS_SUCCESS = "GET_BILL_CONFIGS_SUCCESS"
export const GET_BILL_CONFIGS_FAILED = "GET_BILL_CONFIGS_FAILED"

export const GET_BILL_CONFIG = "GET_BILL_CONFIG"
export const GET_BILL_CONFIG_SUCCESS = "GET_BILL_CONFIG_SUCCESS"
export const GET_BILL_CONFIG_FAILED = "GET_BILL_CONFIG_FAILED"

export const REGISTER_BILL_CONFIG = "REGISTER_BILL_CONFIG"
export const REGISTER_BILL_CONFIG_SUCCESS = "REGISTER_BILL_CONFIG_SUCCESS"
export const REGISTER_BILL_CONFIG_FAILED = "REGISTER_BILL_CONFIG_FAILED"

export const UPDATE_BILL_CONFIG = "UPDATE_BILL_CONFIG"
export const UPDATE_BILL_CONFIG_SUCCESS = "UPDATE_BILL_CONFIG_SUCCESS"
export const UPDATE_BILL_CONFIG_FAILED = "UPDATE_BILL_CONFIG_FAILED"

export const DELETE_BILL_CONFIG = "DELETE_BILL_CONFIG"
export const DELETE_BILL_CONFIG_SUCCESS = "DELETE_BILL_CONFIG_SUCCESS"
export const DELETE_BILL_CONFIG_FAILED = "DELETE_BILL_CONFIG_FAILED"

export const BILL_CONFIG_LIST_REFRESH = "BILL_CONFIG_LIST_REFRESH"
